import { DashboardFilter } from "../../types/dashboard";

interface ISelectedFiltersProps {
  requestFilters: DashboardFilter;
}

const SelectedFilters = ({ requestFilters }: ISelectedFiltersProps) => {
  const checkingAvailableFilters = () => {
    if (
      !requestFilters?.branchIds?.length &&
      !requestFilters?.segmentIds?.length &&
      !requestFilters?.clientIds?.length &&
      !requestFilters?.vehicleIds?.length &&
      !requestFilters?.driverIds?.length
    )
      return false;

    return true;
  };

  const branchs = requestFilters?.branchIds?.length;
  const segments = requestFilters?.segmentIds?.length;
  const clients = requestFilters?.clientIds?.length;
  const vehicles = requestFilters?.vehicleIds?.length;
  const drivers = requestFilters?.driverIds?.length;

  return (
    <div className="display-flex align-items-center gap-10">
      {checkingAvailableFilters() ? (
        <>
          <p className="margin-0 text-size-18 text-bold">Visão detalhada da operação selecionada:</p>
          <div className="display-flex align-items-center gap-20">
            {branchs ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-building text-size-16 margin-top-2"></span>
                <p className="margin-0 text-size-16">{branchs}</p>
                <p className="margin-0 text-size-16">{branchs === 1 ? "Filial" : "Filiais"}</p>
              </div>
            ) : null}

            {segments ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-role-management text-size-16 margin-top-2"></span>
                <p className="margin-0 text-size-16">{segments}</p>
                <p className="margin-0 text-size-16">{segments === 1 ? "Segmento" : "Segmentos"}</p>
              </div>
            ) : null}

            {clients ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-transfer text-size-16 margin-top-2"></span>
                <p className="margin-0 text-size-16">{clients}</p>
                <p className="margin-0 text-size-16">{clients === 1 ? "Cliente" : "Clientes"}</p>
              </div>
            ) : null}

            {vehicles ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-truck text-size-16 margin-top-2"></span>
                <p className="margin-0 text-size-16">{vehicles}</p>
                <p className="margin-0 text-size-16">{vehicles === 1 ? "Veículo" : "Veículos"}</p>
              </div>
            ) : null}

            {drivers ? (
              <div className="display-flex align-items-center gap-5">
                <span className="rioglyph rioglyph-driver text-size-16 margin-top-2"></span>
                <p className="margin-0 text-size-16">{drivers}</p>
                <p className="margin-0 text-size-16">{drivers === 1 ? "Motorista" : "Motoristas"}</p>
              </div>
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default SelectedFilters;
